import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

// project-imports
import Notification from "./Notification";
import MobileHeaderMenu from "./MobileHeaderMenu";
import AdminNotificationSection from "components/AdminNotificationSection"; // Import the admin notification component
import CountrySelector from "components/CountrySelector";
import GlobalPointsDisplay from "./GlobalPointsDisplay";

import { MenuOrientation } from "config";
import useConfig from "hooks/useConfig";
import DrawerHeader from "layout/Dashboard/Drawer/DrawerHeader";
import NavUser from "../../Drawer/DrawerContent/NavUser";

import QuickNavButton from "./QuickNavButton";
import useAuth from "hooks/useAuth";
import { canAccessAdminPanel, isFullAdmin } from "utils/adminAccess";

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();
  const { user } = useAuth();
  const isAdmin = canAccessAdminPanel(user);

  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const downXS = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      <Box sx={{ width: "100%", ml: 1 }} />

      {/* Desktop/Tablet - Show all elements */}
      {!downXS && (
        <Stack
          direction="row"
          spacing={{ xs: 1, sm: 2 }}
          alignItems="center"
          sx={{
            mr: { xs: 1, sm: 2 },
          }}
        >
          <CountrySelector />
          <GlobalPointsDisplay />
          <QuickNavButton isAdmin={isAdmin} />
          <AdminNotificationSection />
          {isFullAdmin(user) ? null : <Notification />}
        </Stack>
      )}

      {/* Mobile - Show menu button */}
      {downXS && <MobileHeaderMenu />}

      {/* NavUser - Show on all screens except mobile */}
      {!downXS && <NavUser />}
    </>
  );
}
